import { defineMessages } from 'react-intl';

export default defineMessages({
  intro: {
    defaultMessage: `SHOW ALL`,
    id: 'app.result.title'
  },
  noResult: {
    defaultMessage: `No result`,
    id: 'app.result.noresult'
  }
});



// WEBPACK FOOTER //
// ./src/containers/result/messages.js